import React from 'react';
import { useForm } from 'react-hook-form';
import { ArcButton, ArcDialog, ArcOutlinedInput, ArcStack } from '@src/core/ui';
import { REQUIRED_VALIDATION_TEXT } from '@src/core/config';
import { ISaveTemplateForm, SaveTemplateDialogProps } from './types';

const SaveTemplateDialog: React.FC<SaveTemplateDialogProps> = (props) => {
  const { open, onClose, defaultName, onSubmit, isSubmitting, title = 'Save as Template', submitLabel = 'Save' } = props;
  const { register, handleSubmit, reset, formState: { errors } } = useForm<ISaveTemplateForm>();

  React.useEffect(() => {
    if (open) {
      reset({ name: defaultName ?? '' });
    }
  }, [open, defaultName, reset]);

  return (
    <ArcDialog open={open} onClose={onClose} title='Save as Template'>
      <ArcStack
        spacing={2}
        component='form'
        onSubmit={handleSubmit(onSubmit)}
      >
        <ArcOutlinedInput
          fullWidth
          label='Template name'
          autoComplete='off'
          error={Boolean(errors.name)}
          helperText={errors.name?.message}
          {...register('name', { required: REQUIRED_VALIDATION_TEXT })}
        />
        <ArcButton.brand size='large' type='submit' fullWidth isLoading={isSubmitting}>
          {submitLabel}
        </ArcButton.brand>
      </ArcStack>
    </ArcDialog>
  );
};

export default SaveTemplateDialog;
